/**
 * @GENERATED from Figma node 3638:52262
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const FlashDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#F25123"
      d="M14.359 14.455v-2.759H6.785V7.068h8.041V4.332H3.792V21h2.993v-6.546zM20.207 21V3h-3.062v18z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(FlashDark);
export { ForwardRef as FlashDark };
